import React from "react"
import { Text } from "react-native"
import { Typography } from "../styles"

export default function SmallText({ children, style }) {
  return <Text style={[Typography.smallBodyText, style]}>{children}</Text>
}
